import { createFileRoute } from "@tanstack/react-router"
import { issueTypeSettingsStaticData } from "src/views/IssueTypeSettingsView/constants"
import { IssueTypeSettingsView } from "src/views/IssueTypeSettingsView/IssueTypeSettingsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/issue-types/")({
	component: IssueTypeSettingsView,
	staticData: issueTypeSettingsStaticData,
})
